import React from 'react';
import background from '../img/softwarePartners.png';
import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react';

function Status({ navbar }) {
  const [changelog, setChangelog] = useState([]);
  const getData = () => {
    fetch('/changelog.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        console.log(response);
        return response.json();
      })
      .then(function (myJson) {
        console.log(myJson);
        setChangelog(myJson);
      });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="bg-[#212121]">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          {navbar}
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">Release Notes</h3>
          </div>
          {changelog &&
            changelog.length > 0 &&
            changelog.map(
              (release, index) =>
                release.title && (
                  <div
                    key={index}
                    className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10"
                  >
                    <p className="text-black large">{release.title}</p>
                    <ul className="ml-5 list-disc">
                      {release.changes.map((item, index) => (
                        <li key={index} className="text-base font-normal text-black">
                          <div
                            style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                            dangerouslySetInnerHTML={{ __html: item }}
                          ></div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )
            )}
        </div>
      </section>
    </>
  );
}

export default Status;
